import { useContext, useState, useEffect, useRef } from 'react';
import { MyContext } from '../../Context/MyProvider';
import Razorpay from './Razorpay';
import BtnLoader from '../BtnLoader';
import secureLocalStorage from 'react-secure-storage';
import AllPayment from './AllPayment';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import ImageLoad from '../ImageLoad';


const Payment = ({ Amount, setIsModel, index, selectPayment, setSelectPayment, paymentList, Data, bankData }) => {

    const { t } = useTranslation();
    const { BaseUrl, setShowToast, setToastMsg, paymentRes, paymentloading, setPaymentRes, setPaymentLoading } = useContext(MyContext);


    const [input, setInput] = useState("");
    const [isTrue, setIsTrue] = useState(false);
    const [payModel, setPayModel] = useState("");
    const [payPhoto, setPayPhoto] = useState("");
    const [copiedKey, setCopiedKey] = useState(null);

    const handleCopy = (text, key) => {
        navigator.clipboard.writeText(text);
        setCopiedKey(key);
        setTimeout(() => setCopiedKey(null), 2000);
    };

    const InputRef = useRef(null);

    useEffect(() => {
        if (Amount) {
            setInput(Amount);
        }
    }, [Amount]);

    useEffect(() => {
        if (!paymentRes) return;
        setIsTrue(false);
    }, [paymentRes]);

    const handleContinue = () => {

        if (index === 2 && !input) {
            setShowToast(true);
            setToastMsg("Please enter amount !!");
            return;
        }

        if (!selectPayment) {
            setShowToast(true);
            setToastMsg("Please select payment method");
            return;
        }

        if (index === 1) {
            setIsModel("");
        }

        if (selectPayment?.id === 10 || selectPayment?.id === 11) {
            if (index === 2) {
                const Data = {
                    payment_id: selectPayment?.id,
                    amount: input
                }
                secureLocalStorage.setItem("paymentData", JSON.stringify(Data));
            }
            setPayModel(selectPayment?.id === 10 ? "Code" : "Bank");
            return;
        }

        if (index === 2) {
            const Data = {
                payment_id: selectPayment?.id,
                amount: input
            }
            secureLocalStorage.setItem("paymentData", JSON.stringify(Data));
        }

        if (Data) {
            const LocalData = { ...Data, payment_id: selectPayment?.id, payment_img: "" }
            secureLocalStorage.setItem("Booking", JSON.stringify(LocalData));
        }

        if (selectPayment?.id === 9) {
            setPaymentRes("PaymentDone");
            return;
        }

        secureLocalStorage.setItem("Page", index === 2 ? "/wallet" : (index === 3 ? "/my-rides" : ""));

        setIsTrue(true);
        setPaymentLoading(true);
    }

    const handlePayByQRCode = async () => {

        if (!payPhoto) {
            setShowToast(true);
            setToastMsg("Please select payment image !!");
            return;
        }

        const base64Image = await convertToBase64(payPhoto);

        if (index === 2) {
            const existing = secureLocalStorage.getItem("paymentData");
            let pData = {};
            if (existing) {
                try { pData = JSON.parse(existing); } catch(e) {}
            }
            pData.payment_img = base64Image;
            secureLocalStorage.setItem("paymentData", JSON.stringify(pData));
        }

        const LocalData = {
            ...Data,
            payment_id: selectPayment?.id,
            payment_img: base64Image
        };

        secureLocalStorage.setItem("Booking", JSON.stringify(LocalData));

        setPaymentRes("PaymentDone");
        setPayModel("");
    }

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    return (
        <div>

            {index !== 3 && <div className="flex items-center justify-between mb-2">
                <h1 className='font-medium text-[20px]'>{index === 1 ? t("Select Paymet Method") : t("Add Wallet Amount")}</h1>
                <button onClick={() => { setSelectPayment(null); setIsModel(""); }} className='hover:bg-gray-100 rounded-full p-2'>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" />
                    </svg>
                </button>
            </div>}

            {index === 2 && <input type="number" value={input} onChange={(e) => setInput(e.target.value)} className="w-full mb-2 border px-[15px] py-[8px] rounded-[10px] outline-[--bg-color]" placeholder={t("Enter amount")} />}

            {index === 2 && <h1 className='font-medium text-gray-600 mb-1'>{t("Select Paymet Method")}</h1>}

            <div className={`${index !== 3 ? "max-h-[400px]" : "h-[calc(100vh-325px)]"} scroll-container space-y-3`}>
                {paymentList.map((item, listindex) => {
                    const IsSelect = item.id === selectPayment?.id;
                    const IsShow = index === 2 ? item.wallet_status === "1" : true;
                    if (IsShow) {
                        return <div key={listindex} onClick={() => { setSelectPayment(item); }} className={`border-[2px] px-[15px] py-[10px] rounded-[15px] flex items-center justify-between gap-2 cursor-pointer translate-all duration-300 ${IsSelect ? "border-[--bg-color]" : "border-gray-200"}`}>
                            <div className="flex items-center gap-3 overflow-hidden">
                                <img src={BaseUrl + item.image} className="max-w-[50px] min-w-[50px] h-[50px] shadow rounded-[15px] overflow-hidden" alt={item.name} />
                                <div className="leading-5">
                                    <h1 className="font-semibold text-gray-700">{item.name}</h1>
                                    <p className="text-gray-600 text-[15px] leading-5 line-clamp-2">
                                        {item.sub_title}
                                    </p>
                                </div>
                            </div>
                            <div className="max-w-7 min-w-7">
                                <div className={`w-5 h-5 rounded-full border-[2px] flex items-center justify-center translate-all duration-300 ${IsSelect ? "border-[--bg-color]" : "border-gray-200"}`}>
                                    <div className={`w-2.5 h-2.5 ${IsSelect ? "bg-[--bg-color]" : "bg-white"} rounded-full translate-all duration-300`}></div>
                                </div>
                            </div>
                        </div>
                    }
                })}
            </div>

            <button onClick={handleContinue} className='w-full h-[45px] bg-[--bg-color] hover:bg-[--bg-color-hover] text-white mt-3 rounded-[10px] but-hover font-medium italic hover:shadow-lg active:scale-[0.97] transition-all'>
                {paymentloading
                    ? <BtnLoader CustomeStyle={"bg-white"} />
                    : t("Continue")}
            </button>

            {(selectPayment?.name === "Razorpay" && isTrue) && <Razorpay Amount={input} attributes={selectPayment?.attribute} />}
            {(selectPayment?.name === "Paypal" && isTrue) && <AllPayment Amount={input} PaymentUrl={"payment/paypal-payment?"} />}
            {(selectPayment?.name === "Stripe" && isTrue) && <AllPayment Amount={input} PaymentUrl={"payment/strip-payment?"} />}
            {(selectPayment?.name === "PayStack" && isTrue) && <AllPayment Amount={input} PaymentUrl={"payment/payStack-payment?"} />}
            {(selectPayment?.name === "FlutterWave" && isTrue) && <AllPayment Amount={input} PaymentUrl={"payment/flutterWave-payment?"} />}
            {(selectPayment?.name === "SenangPay" && isTrue) && <AllPayment Amount={input} PaymentUrl={"payment/senangPay-payment?"} />}
            {(selectPayment?.name === "Payfast" && isTrue) && <AllPayment Amount={input} PaymentUrl={"payment/payfast-payment?"} />}
            {(selectPayment?.name === "Midtrans" && isTrue) && <AllPayment Amount={input} PaymentUrl={"payment/midtrans-payment?"} />}

            <AnimatePresence initial={false}>
                {payModel === "Code" && <div className="model items-center justify-center backdrop-blur-sm bg-black/40 z-[99999]">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, scale: 1, y: 0 },
                            close: { opacity: 0, scale: 0.95, y: 15 },
                        }}
                        transition={{ duration: 0.25, ease: "easeOut" }}
                        className='w-[460px] bg-white p-6 rounded-2xl shadow-2xl relative mx-4 border border-gray-100'
                    >
                        <div className="flex items-center justify-between mb-5">
                            <div>
                                <h1 className='font-bold text-[20px] text-gray-800'>
                                    {selectPayment?.name || "Pay with QR Code"}
                                </h1>
                                <p className='text-xs text-gray-500 mt-0.5'>Scan the QR code to complete payment and upload receipt</p>
                            </div>
                            <button onClick={() => { setPayModel(""); setPayPhoto(""); }} className='hover:bg-gray-100 rounded-full p-2 text-gray-500 hover:text-gray-700 transition-colors'>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5" />
                                </svg>
                            </button>
                        </div>

                        <div className="flex flex-col items-center gap-6 mb-6">
                            {/* QR Code Container */}
                            <div className="p-3 bg-gray-50 rounded-2xl border border-gray-100 shadow-sm flex items-center justify-center">
                                <ImageLoad src={BaseUrl + selectPayment?.attribute} CustomeStyle={"w-[160px] h-[160px]"} ImagStyle={"w-full h-full object-contain rounded-lg"} alt={"Qr code"} status={false} />
                            </div>

                            {/* Creative Receipt Upload Block */}
                            <div className="w-full">
                                <span className='block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2'>Upload Payment Receipt</span>
                                {payPhoto ? (
                                    <div className='relative w-full h-[130px] rounded-xl overflow-hidden border border-gray-200 shadow-inner group'>
                                        <img src={URL.createObjectURL(payPhoto)} className='w-full h-full object-cover' alt="uploaded-receipt" />
                                        <div className='absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity duration-200'>
                                            <button 
                                                onClick={() => setPayPhoto("")} 
                                                className='bg-red-500 hover:bg-red-600 text-white rounded-full p-2.5 shadow-lg active:scale-95 transition-all'
                                                title="Remove Image"
                                            >
                                                <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <label htmlFor="qr-receipt-upload" className="flex flex-col items-center justify-center w-full h-[130px] border-2 border-dashed border-gray-300 hover:border-[--bg-color] bg-gray-50 hover:bg-gray-50/50 rounded-xl cursor-pointer transition-all group">
                                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                            <svg className="w-8 h-8 text-gray-400 group-hover:text-[--bg-color] transition-colors mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            <p className="text-sm font-semibold text-gray-600 group-hover:text-[--bg-color] transition-colors">Select Receipt Image</p>
                                            <p className="text-xs text-gray-400 mt-1">Supports PNG, JPG, JPEG</p>
                                        </div>
                                        <input id="qr-receipt-upload" type="file" accept="image/*" onChange={(e) => setPayPhoto(e.target.files[0])} className="hidden" />
                                    </label>
                                )}
                            </div>
                        </div>

                        <button onClick={handlePayByQRCode} className='w-full h-[48px] bg-[--bg-color] hover:bg-[--bg-color-hover] text-white rounded-xl but-hover font-semibold hover:shadow-lg active:scale-[0.98] transition-all flex items-center justify-center text-[15px]'>
                            {paymentloading
                                ? <BtnLoader CustomeStyle={"bg-white"} />
                                : t("Continue")}
                        </button>
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {payModel === "Bank" && <div className="model items-center justify-center backdrop-blur-sm bg-black/40 z-[99999]">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, scale: 1, y: 0 },
                            close: { opacity: 0, scale: 0.95, y: 15 },
                        }}
                        transition={{ duration: 0.25, ease: "easeOut" }}
                        className='w-[460px] bg-white p-6 rounded-2xl shadow-2xl relative mx-4 border border-gray-100'
                    >
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <h1 className='font-bold text-[20px] text-gray-800'>
                                    {selectPayment?.name || "Bank Account Transfer"}
                                </h1>
                                <p className='text-xs text-gray-500 mt-0.5'>Transfer funds manually to the bank account below</p>
                            </div>
                            <button onClick={() => { setPayModel(""); setPayPhoto(""); }} className='hover:bg-gray-100 rounded-full p-2 text-gray-500 hover:text-gray-700 transition-colors'>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5" />
                                </svg>
                            </button>
                        </div>

                        {/* Beautifully Copyable Bank details box */}
                        <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 mb-5 space-y-3 shadow-inner">
                            <span className='block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1'>Bank Account Details</span>
                            {bankData.map((item, index) => {
                                const key = Object.keys(item)[0];
                                const value = Object.values(item)[0];
                                const displayName = key.replaceAll("_", " ");
                                const isCopied = copiedKey === key;

                                return (
                                    <div key={index} className="flex items-center justify-between border-b border-slate-100 last:border-0 pb-2 last:pb-0">
                                        <span className="text-gray-400 text-sm capitalize">{displayName}</span>
                                        <div className="flex items-center gap-2">
                                            <span className="font-semibold text-gray-800 text-sm select-all">{value}</span>
                                            <button 
                                                onClick={() => handleCopy(value, key)} 
                                                className={`p-1.5 rounded-md hover:bg-white border border-transparent hover:border-gray-200 transition-all active:scale-90 ${isCopied ? 'text-green-600' : 'text-gray-400 hover:text-gray-600'}`}
                                                title="Copy to clipboard"
                                            >
                                                {isCopied ? (
                                                    <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                    </svg>
                                                ) : (
                                                    <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                                    </svg>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Receipt Upload area */}
                        <div className="w-full mb-6">
                            <span className='block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2'>Upload Payment Receipt</span>
                            {payPhoto ? (
                                <div className='relative w-full h-[130px] rounded-xl overflow-hidden border border-gray-200 shadow-inner group'>
                                    <img src={URL.createObjectURL(payPhoto)} className='w-full h-full object-cover' alt="uploaded-receipt" />
                                    <div className='absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity duration-200'>
                                        <button 
                                            onClick={() => setPayPhoto("")} 
                                            className='bg-red-500 hover:bg-red-600 text-white rounded-full p-2.5 shadow-lg active:scale-95 transition-all'
                                            title="Remove Image"
                                        >
                                            <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <label htmlFor="bank-receipt-upload" className="flex flex-col items-center justify-center w-full h-[130px] border-2 border-dashed border-gray-300 hover:border-[--bg-color] bg-gray-50 hover:bg-gray-50/50 rounded-xl cursor-pointer transition-all group">
                                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                        <svg className="w-8 h-8 text-gray-400 group-hover:text-[--bg-color] transition-colors mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        <p className="text-sm font-semibold text-gray-600 group-hover:text-[--bg-color] transition-colors">Select Receipt Image</p>
                                        <p className="text-xs text-gray-400 mt-1">Supports PNG, JPG, JPEG</p>
                                    </div>
                                    <input id="bank-receipt-upload" type="file" accept="image/*" onChange={(e) => setPayPhoto(e.target.files[0])} className="hidden" />
                                </label>
                            )}
                        </div>

                        <button onClick={handlePayByQRCode} className='w-full h-[48px] bg-[--bg-color] hover:bg-[--bg-color-hover] text-white rounded-xl but-hover font-semibold hover:shadow-lg active:scale-[0.98] transition-all flex items-center justify-center text-[15px]'>
                            {paymentloading
                                ? <BtnLoader CustomeStyle={"bg-white"} />
                                : t("Continue")}
                        </button>
                    </motion.div>
                </div>}
            </AnimatePresence>

        </div>
    )
}

export default Payment